import { FC } from 'react'
import { IProductBase, IUserAttachmentBase } from '@/types'
import { CompanyPanel } from '@/components/molecules/CompanyPanel'
import { getProductImage, getUserAttachmentImage, sanitizeUrl } from '@/utils'
import { TokenLogoAndName } from '@/components/molecules/TokenLogoAndName'
import styles from './index.module.scss'

type Props = {
  product?: IProductBase
  portfolio?: IUserAttachmentBase
}

export const ProductPanel: FC<Props> = ({ product, portfolio }) => {
  const item = product || portfolio
  const src = product ? getProductImage(product) : getUserAttachmentImage(portfolio)
  return (
    <CompanyPanel src={src} alt={item.name}>
      <div className={styles.container}>
        <div className={styles.heading}>
          <span className={styles.name}>{item.name}</span>
          {item.url && (
            <a className={styles.link} href={sanitizeUrl(item.url)} target='_blank' rel='noreferrer'>
              <img src='/images/common/service_link_icon.svg' alt='Service Link' className={styles.linkIcon} />
              <span className={styles.linkText}>Go to site</span>
            </a>
          )}
        </div>
        {product && (
          <div className={styles.cryptGroup}>
            {product?.blockchains?.length > 0 && (
              <div className={styles.blockchain}>
                {'Chain : '}
                {product?.blockchains?.map((blockchain, i) => {
                  return (
                    <span key={blockchain.slug}>
                      {product?.blockchains.length - 1 === i ? blockchain.name : `${blockchain.name}・`}
                    </span>
                  )
                })}
              </div>
            )}
            {product?.tokens?.length > 0 && (
              <div className={styles.token}>
                <div className={styles.tokenLabel}>{'Token : '}</div>
                {product?.tokens?.map((token, i) => {
                  return product?.tokens.length - 1 === i ? (
                    <TokenLogoAndName token={token} small key={token.slug} />
                  ) : (
                    <TokenLogoAndName token={token} small withDot key={token.slug} />
                  )
                })}
              </div>
            )}
          </div>
        )}
        <div className={styles.description}>{item.description}</div>
      </div>
    </CompanyPanel>
  )
}
